<script>
import Emitter from 'element-ui/lib/mixins/emitter';

const keyCode = Object.freeze({
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  TAB: 9
});

export default {
  name: 'ElCheckboxGroup',

  componentName: 'ElCheckboxGroup',

  mixins: [Emitter],

  inject: {
    elFormItem: {
      default: ''
    }
  },

  props: {
    value: {}, // eslint-disable-line
    disabled: Boolean,
    min: Number,
    max: Number,
    size: String,
    fill: String,
    textColor: String
  },

  computed: {
    _elFormItemSize () {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxGroupSize () {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },

  watch: {
    value (value) {
      this.dispatch('ElFormItem', 'el.form.change', [value]);
    }
  },

  methods: {
    handleKeydown (e) {
      const target = e.target;
      const className =
        target.nodeName === 'INPUT' ? '[type=checkbox]' : '[role=checkbox]';
      const checkboxes = this.$el.querySelectorAll(className);
      const length = checkboxes.length;
      const index = [].indexOf.call(checkboxes, target);
      const roleCheckboxes = this.$el.querySelectorAll('[role=checkbox]');

      switch (e.keyCode) {
        case keyCode.LEFT:
        case keyCode.UP:
          e.stopPropagation();
          e.preventDefault();
          if (index === 0) {
            roleCheckboxes[length - 1].focus();
          } else {
            roleCheckboxes[index - 1].focus();
          }
          break;
        case keyCode.RIGHT:
        case keyCode.DOWN:
          e.stopPropagation();
          e.preventDefault();
          if (index === length - 1) {
            roleCheckboxes[0].focus();
          } else {
            roleCheckboxes[index + 1].focus();
          }
          break;
        case keyCode.ENTER:
          e.stopPropagation();
          e.preventDefault();
          roleCheckboxes[index].click();
          break;
        default:
          break;
      }
    }
  }
};
</script>

<template>
  <div
    class="el-checkbox-group"
    role="group"
    aria-label="checkbox-group"
    @keydown="handleKeydown"
  >
    <slot></slot>
  </div>
</template>



// WEBPACK FOOTER //
// checkbox-group.vue?9f5e759e